import { render, staticRenderFns } from "./GeodirMapLosAndes.vue?vue&type=template&id=0710d51f"
import script from "./GeodirMapLosAndes.vue?vue&type=script&lang=js"
export * from "./GeodirMapLosAndes.vue?vue&type=script&lang=js"
import style0 from "./GeodirMapLosAndes.vue?vue&type=style&index=0&id=0710d51f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports